/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const s = "splitBarLabel", a = {
  [s]: "split bar"
};
export {
  a as messages,
  s as splitBarLabel
};
